// @flow
import styled from 'styled-components';
/*::
import type { DataPresenterThemeType } from '../';
*/

var thm
/*: DataPresenterThemeType */
= {
  PlaceHolder: styled.span.withConfig({
    displayName: "theme__PlaceHolder",
    componentId: "sc-1yy4uu0-0"
  })(["display:inline-block;height:", "rem;width:", "rem;background-color:", ";vertical-align:middle;"], function (pr) {
    return pr.height;
  }, function (pr) {
    return pr.width;
  }, function (pr) {
    return pr.bgcolor;
  })
};
export default thm;